// extracted by mini-css-extract-plugin
export var errorsContainer = "_t2-1";
export var link = "_t2-0";